import queryString from "query-string";
import { useCallback, useEffect, useState } from "react";
import { isSSR } from "@picovico/utils";

export function useRouter() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [router, setRouter] = useState<any>({
    pathname: "",
    replace: () => {},
  });

  const path = isSSR() ? "" : window?.location?.pathname;

  const loadNextRouter = useCallback(() => {
    import("next/router")
      .then((nextRouter) => {
        setRouter({
          replace: nextRouter.default.replace,
          pathname: nextRouter.default.pathname,
          push: nextRouter.default.push,
          query: nextRouter.default.query,
        });
      })
      .catch(() => {
        setRouter({
          replace: window.location.replace,
          push: (url: string) => {
            window.location.href = url;
          },
          pathname: window.location.pathname,
          query: {
            ...queryString.parse(window.location.search),
          },
        });
      });
  }, []);

  useEffect(() => {
    loadNextRouter();
  }, [loadNextRouter, path]);

  return router;
}
